import { Route, Routes } from 'react-router-dom';
import { NotFound, Logs } from '@pages';
import Protected from '@components/Protected';

function RoutesDriver() {
  return (
    <Protected>
      <Routes>
        <Route index element={<Logs />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Protected>
  );
}
export default RoutesDriver;
